import { FilterOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface FiltersButtonProps {
  isViewSelectedFilters: boolean;
  selectedFiltersLength: number;
  onClick: () => void;
}

export const FiltersButton: React.FC<FiltersButtonProps> = ({
  isViewSelectedFilters,
  selectedFiltersLength,
  onClick,
}) => {
  return (
    <Button type="default" className="text-neutral-900" onClick={onClick}>
      <div className="flex items-center justify-center gap-2 px-1">
        <FilterOutlined />
        <div>Filter</div>
        {selectedFiltersLength > 0 && (
          <div className="h-4 w-4 bg-neutral-800 rounded-full flex flex-col justify-center items-center text-white text-xs font-semibold leading-none">
            {selectedFiltersLength}
          </div>
        )}
        {!isViewSelectedFilters && <div className="absolute -top-1 -right-1 mb-4 w-2 h-2 bg-orange-600 rounded-full" />}
      </div>
    </Button>
  );
};
